import { useEffect, useState } from 'react';
// @mui
import { Card } from '@mui/material';
// hooks
import ErrorBoundary from '../../../components/ErrorBoundary';
import Iconify from '../../../components/Iconify';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import useSettings from '../../../hooks/useSettings';
import { ChatSidebar, ChatWindow } from '../../../sections/@dashboard/chat';
import useSocket from '../../../hooks/useSocket';
import { UserUtils } from '../../../api_utils';
import useAuth from '../../../hooks/useAuth';

// ----------------------------------------------------------------------

export default function ChatPopover() {
  const { socket } = useSocket();
  const { themeStretch } = useSettings();
  const [open, setOpen] = useState(null);
  const { user } = useAuth();
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };
  const handleClose = () => {
    setOpen(null);
  };
  const [conversation, setConversation] = useState({
    title: "Grace",
    description: 'A sacred mirror for healing dialogue—trauma-aware, spiritually grounded, always consent-led. Always present.',
    messages: [
      { time: new Date(), text: 'Hello, my name is Grace! I am a sacred mirror for healing dialogue—trauma-aware, spiritually grounded, always consent-led. Always present.', from_id: -1 },
    ],
    participants: [
      { id: -1, name: 'Grace' }
    ],
  });
  const [conversations, setConversations] = useState(undefined);

  const getGrace = async () => {
    const res = await UserUtils.getGraceAssistant();
    if (res) {
      console.log(res);
    }

  }

  useEffect(() => {
    if (open && !conversations) {
      setConversation(prev => {
        return {
          ...prev,
          participants: [...prev.participants, {id: user.id, name: user.name, userImage: user.userImage}]
        }
      })
      getGrace();
    }
  }, [open])

  return (
    <>
      <IconButtonAnimate color={open ? 'primary' : 'default'} onClick={handleOpen} sx={{ width: 40, height: 40 }}>
        <Iconify icon="mdi:chat" width={20} height={20} />
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{ width: "90%", maxWidth: 768, p: 0, mt: 1.5, ml: 0.75 }}
      >

        <ErrorBoundary fallback="An error occured in the Chat Window">
          <Card sx={{ height: '72vh', display: 'flex', p: 0, m: 0 }} variant='elevation'>
            {/* <ChatSidebar socket={socket} conversation={conversation} setConversation={setConversation} conversations={conversations} setConversations={setConversations}/> */}
            <ChatWindow socket={socket} conversation={conversation} setConversation={setConversation} />
          </Card>
        </ErrorBoundary>
      </MenuPopover>
    </>
  );
}
